var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    screen_popup: true,
    overlay: _vm.overlay,
  }},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"header"},[_c('base-button',{staticClass:"close_btn",attrs:{"id":"close_screen_popup_btn","text":"X","theme":"CLEAR"},on:_vm._d({},[_vm.EVENTS.CLICK,function($event){return _vm.$emit(_vm.EVENTS.CLOSE)}])})],1),_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }